<template>
    <div class="w-screen h-screen bg-gradient-to-b from-purple-100 to-purple-200 fixed top-0 left-0 -z-10"> </div>
    <div class="container mx-auto px-12 text-center">
        <app-logo class="w-screen lg:max-w-lg mx-auto mt-40 lg:mt-60" theme="light"></app-logo>

        <h1 class="text-white mt-20 text-2xl font-bold lg:text-4xl lg:px-44 xl:px-[16rem] !leading-[3rem]">
            Genuine reviews to help you find the best websites to use
        </h1>

        <h3 class="text-white mt-20">
            Coming soon...
        </h3>

        <div class="text-grey-100 text-center mb-12 mt-40">
            &copy; {{ currentYear }}
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import AppLogo from '@/Components/AppLogo.vue';

export default {
    components: {
        AppLogo
    },
    layout: null,
    computed: {
        currentYear() {
            return dayjs().format("YYYY");
        }
    }
};
</script>
